// Copy of the older pages (market simulation, cookie banner, footer, contact,
// imprint) per site language. english.ts and german.ts are edited by hand;
// the other languages are translations of english.ts without the imprint,
// which is a legal text and stays in English for them.
import en from "./english/english";
import de from "./german/german";
import fr from "./locales/fr/legacy.json";
import es from "./locales/es/legacy.json";
import it from "./locales/it/legacy.json";
import pl from "./locales/pl/legacy.json";
import zh from "./locales/zh/legacy.json";
import ja from "./locales/ja/legacy.json";
import ko from "./locales/ko/legacy.json";
// Corrections for german.ts (left untouched on purpose): the market-simulation
// home texts and the plans were partly English or mistranslated there.
import deFixes from "./locales/de/legacy-overrides.json";

import { Lang } from "./languages";

export type LegacyCopy = typeof en;

const translated = (copy: Omit<LegacyCopy, "imprint">): LegacyCopy => ({
  ...copy,
  imprint: en.imprint,
});

/** Deep merge for the sparse German corrections: objects and arrays are
 *  merged key by key (array indices as object keys), so every value the
 *  override does not mention – prices, ids, flags – still comes from german.ts. */
const mergeFixes = (base: any, fixes: any): any => {
  if (fixes === undefined) return base;
  if (typeof fixes !== "object" || fixes === null) return fixes;
  const out: any = Array.isArray(base) ? [...base] : { ...base };
  Object.keys(fixes).forEach((key) => {
    out[key] = mergeFixes(base?.[key], fixes[key]);
  });
  return out;
};

const legacy: Record<Lang, LegacyCopy> = {
  en,
  de: mergeFixes(de, deFixes) as LegacyCopy,
  fr: translated(fr),
  es: translated(es),
  it: translated(it),
  pl: translated(pl),
  zh: translated(zh),
  ja: translated(ja),
  ko: translated(ko),
};

export default legacy;
